import { cn } from "@/lib/utils";

const FormLabel = ({
  children,
  className,
  isCheckbox = false,
}: {
  children: React.ReactNode;
  className?: string;
  isCheckbox?: boolean;
}) => (
  <label
    className={cn(
      "px-[6px] bg-white text-[14px] font-[400] text-black flex items-center",
      className,
      isCheckbox ? "" : "top-[-9px] left-[14px] z-1 mb-1"
    )}
  >
    {children}
  </label>
);

export default FormLabel;
